import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { affectVehicle } from "../services/vehiculeApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin, Tag } from "antd";
import { CarOutlined, LinkOutlined } from "@ant-design/icons";
import { getDrivers } from "../../Users/services/userApi";
import SelectField from "../../../Components/Common/Form/SelectField";
import "../../Styles/style.css";

const AffectVehicleForm = ({ modal, setModal, toggle, selectedVehicule, actualDriver }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);

  const { isLoading, isError, error, data: users } = useQuery("users", getDrivers);
  const drivers = users?.filter(user => user.role?.name === "DRIVER");
  const nameVehicle = selectedVehicule?.brand || "-";
  
  const validationSchema = Yup.object().shape({
    driver: Yup.string().required("Veuillez Choisir un chauffeur")
  });

  const initialValues = selectedVehicule ? {
    name: selectedVehicule.brand,
    driver: selectedVehicule.driver?.id || "",
  } : {
    name: "",
    driver: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      try {
        const { driver } = values; 
        await affectVehicle(driver, selectedVehicule);
        toast.success(`La voiture a été affectée avec succès 🎉`);
        await queryClient.invalidateQueries("vehicules");
        toggle();
        formik.resetForm();
      } catch (error) {
        console.error("Erreur lors de l'affectation de la voiture :", error?.message || error);
        toast.error("😌 Erreur lors de l'affectation de la voiture :", error?.message || error);
      } finally {
        setisLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedVehicule]);

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "800px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <LinkOutlined /> Affectation du véhicule {nameVehicle} à un chauffeur 
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
            <Row>
              <Col lg={6}>
                <label htmlFor="nameVehicle" className="form-label">Véhicule <CarOutlined /></label>
                <input className="form-control" value={formik.values.name} disabled />
              </Col>
              <Col lg={6}>
                <label htmlFor="actualDriver" className="form-label">Actuel Chauffeur</label>
                <input className="form-control" value={actualDriver} disabled />
              </Col>
              <SelectField
                label="Chauffeur"
                name="driver"
                formik={formik}
                isLoading={isLoading}
                isError={isError}
                options={drivers}
                nameSelect = "un nouveau chauffeur pour ce vehicule"
                error={formik.errors.driver}
                colSize={12}
                isName = {false}
              />
            </Row>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button color="light" className="bordered-btn" onClick={() => setModal(false)}>
              Annuler
            </Button>
            <Button type="submit" className="active-tab" disabled={isLoadingSubmit}>
              {isLoadingSubmit ? <Spin size="small" /> : "Affecter"}
            </Button>
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AffectVehicleForm;
